module.exports = __webpack_public_path__ + "static/img/zgcyxhzp.b86fc30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/zgcyxhzp.jpg
// module id = TCaw
// module chunks = 1